var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "all-paids" } }, [
    _c(
      "div",
      { staticClass: "all-paids-container" },
      [
        _c("ComingSoonWrapper"),
        _vm._v(" "),
        _c("div", { staticClass: "header" }, [_c("FilterTool")], 1),
        _vm._v(" "),
        !_vm.data.length
          ? _c(
              "div",
              {
                staticClass:
                  "h-50 d-flex flex-column justify-content-center align-items-center text-align-center",
              },
              [
                _c("a-spin"),
                _vm._v(" "),
                _c("p", [_vm._v(_vm._s(_vm.$t("message.loading")))]),
              ],
              1
            )
          : _c("LineGraphic", {
              attrs: {
                data: _vm.data,
                "total-data": _vm.totalData,
                "avg-data": _vm.avgData,
                "sub-title": "paidChats",
              },
            }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }